if (!customElements.get('lsg-reveal')) {
  class LsgReveal extends HTMLElement {
    connectedCallback() {
      this._init();
    }

    _getRoot() {
      return (
        this.closest('[data-reveal-root-margin]') ||
        this.closest('.lsg-intro-section')
      );
    }

    _init() {
      const root = this._getRoot();
      if (!root) return;

      this.classList.add('is-reveal-pending');

      // Prevent duplicate triggers
      if (root._lsgBound) return;
      root._lsgBound = true;

      const check = () => {
        if (root.dataset.lsgRevealDone === 'true') return;

        const rect = root.getBoundingClientRect();
        const vh = window.innerHeight;

        const raw = root.dataset.revealThreshold;
        let minFraction = 0.5;
        if (raw !== undefined && raw !== '') {
          const n = Number.parseFloat(String(raw).split(',')[0].trim());
          if (!Number.isNaN(n)) {
            minFraction = n <= 0 ? 0 : Math.min(1, n);
          }
        }

        const overlaps = rect.top < vh && rect.bottom > 0;
        let shouldReveal = false;

        if (minFraction <= 0) {
          shouldReveal = overlaps;
        } else if (overlaps) {
          const visibleTop = Math.max(rect.top, 0);
          const visibleBottom = Math.min(rect.bottom, vh);
          const visibleHeight = Math.max(0, visibleBottom - visibleTop);
          const reference = Math.min(Math.max(rect.height, 1), vh);
          shouldReveal = visibleHeight >= reference * minFraction;
        }

        if (shouldReveal) {
          this._triggerGroupReveal(root);
        }
      };

      // Run immediately + on scroll
      requestAnimationFrame(check);
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);

      // Shopify safe
      window.addEventListener('load', check);
    }

    _triggerGroupReveal(root) {
      if (root.dataset.lsgRevealDone === 'true') return;

      root.dataset.lsgRevealDone = 'true';

      const items = [...root.querySelectorAll('lsg-reveal')].sort(
        (a, b) => (Number(a.dataset.order) || 0) - (Number(b.dataset.order) || 0)
      );

      const reveal = (el) => {
        el.classList.remove('is-reveal-pending');
        el.classList.add('is-revealed');
      };

      for (const el of items) reveal(el);
    }
  }

  customElements.define('lsg-reveal', LsgReveal);
}